/**
 * @generated SignedSource<<8fc4a4cb78339640011bb1e63dd25485>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BillingCycle = "MONTHLY_IN_ADVANCE" | "MONTHLY_IN_ARREARS" | "ONE_TIME" | "QUARTERLY_IN_ADVANCE" | "YEARLY_IN_ADVANCE" | "%future added value";
export type AssignSupplierBillingCycleInput = {
  billingCycle: BillingCycle;
  id: string;
};
export type SuppliersViewAssignBillingCycleMutation$variables = {
  input: AssignSupplierBillingCycleInput;
};
export type SuppliersViewAssignBillingCycleMutation$data = {
  readonly assignSupplierBillingCycle: {
    readonly billingCycle: BillingCycle | null | undefined;
    readonly id: string;
    readonly proposedServicePeriodCount: number;
  };
};
export type SuppliersViewAssignBillingCycleMutation = {
  response: SuppliersViewAssignBillingCycleMutation$data;
  variables: SuppliersViewAssignBillingCycleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "assignSupplierBillingCycle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingCycle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "proposedServicePeriodCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SuppliersViewAssignBillingCycleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SuppliersViewAssignBillingCycleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d64672f261137d900b8d813baaf94e2e",
    "id": null,
    "metadata": {},
    "name": "SuppliersViewAssignBillingCycleMutation",
    "operationKind": "mutation",
    "text": "mutation SuppliersViewAssignBillingCycleMutation(\n  $input: AssignSupplierBillingCycleInput!\n) {\n  assignSupplierBillingCycle(input: $input) {\n    id\n    billingCycle\n    proposedServicePeriodCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "305cef89f024c2ecbdca61de3e51ec22";

export default node;
